import { schema, normalize } from 'normalizr';

export const entity = 'vendorReturns';
export const endpoints = {
  create: ({ payload, onSuccess }) => ({
    url: '/admin/vendor-returns?include=Employee,Vendor.Contact,Vendor.Note,Shop,Note',
    payload,
    entity,
    list: false,
    onSuccess,
  }),
  view: ({ id }) => ({
    url: `/admin/vendor-returns/${id}?include=Employee,Vendor.Contact,Vendor.Note,Shop,Note,Shop.TaxCategory`,
    entity,
    list: false,
  }),
  edit: ({ id, payload, onSuccess }) => ({
    url: `/admin/vendor-returns/${id}?include=Employee,Vendor.Contact,Vendor.Note,Shop,Note`,
    payload,
    entity,
    list: false,
    onSuccess,
  }),
  archive: ({ id, ...rest }) => ({
    url: `/admin/vendor-returns/${id}/archive?include=Employee,Vendor.Contact,Vendor.Note,Shop,Note`,
    entity,
    list: false,
    ...rest,
  }),
  restore: ({ id, ...rest }) => ({
    url: `/admin/vendor-returns/${id}/restore?include=Employee,Vendor.Contact,Vendor.Note,Shop,Note`,
    entity,
    list: false,
    ...rest,
  }),
  send: ({ id, ...rest }) => ({
    url: `/admin/vendor-returns/${id}/send?include=Employee,Vendor.Contact,Vendor.Note,Shop,Note`,
    entity,
    list: false,
    ...rest,
  }),
  reopen: ({ id, ...rest }) => ({
    url: `/admin/vendor-returns/${id}/reopen?include=Employee,Vendor.Contact,Vendor.Note,Shop,Note`,
    entity,
    list: false,
    ...rest,
  }),
  close: ({ id, ...rest }) => ({
    url: `/admin/vendor-returns/${id}/close?include=Employee,Vendor.Contact,Vendor.Note,Shop,Note`,
    entity,
    list: false,
    ...rest,
  }),
  hide: ({ id, ...rest }) => ({
    url: `/admin/vendor-returns/${id}/hide-details?include=Employee,Vendor.Contact,Vendor.Note,Shop,Note`,
    entity,
    list: false,
    ...rest,
  }),
  show: ({ id, ...rest }) => ({
    url: `/admin/vendor-returns/${id}/show-details?include=Employee,Vendor.Contact,Vendor.Note,Shop,Note`,
    entity,
    list: false,
    ...rest,
  }),
};
export const entitySchema = new schema.Entity(
  entity,
  {},
  {
    idAttribute: 'vendorReturnID',
  }
);
export const normalizer = result => normalize(result, entitySchema);
export const listNormalizer = result => normalize(result, [entitySchema]);
